import { createContainer } from 'react-sweet-state';
import type { IntentInferenceProvider } from '../../common/types';

export const RoutingStateContainer = createContainer<{
    intentInferenceProvider: IntentInferenceProvider;
    contextId: string;
}>();
